import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-js-day3',
  templateUrl: './js-day3.component.html',
  styleUrls: ['./js-day3.component.css']
})
export class JsDay3Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
